import apiService from '../../../repositories/apiService';
import BibleStudyPlansRepository from '../../../repositories/BibleStudyPlanRepository';

export default {
    getMaterials({ commit, rootGetters }) {
        return new Promise((resolve, reject) => {
            apiService.get(
                'bible_study_materials'
            ).then((response) => {
                commit('setMaterials', response.data.data);
            }).catch();
        });
    },
    getPlans({ commit }) {
        return this.dispatch(
            'BibleStudyPlans/Pagination/paginatedFetch',
            '/bible_study_plans/my_bible_study_plans',
        )
            .then((response) => {
                commit('setPlans', response.data.data);
            })
            .catch((error) => {
                commit('setError', error);
            });
    },
};
